export const DEFAULT_TIMEZONE = 'Europe/Stockholm'
